import React, { useEffect } from "react";
import ReactGA from "react-ga";
export default function LegacyAnalytics(_ref) {
  var appProps = _ref.appProps;
  useEffect(function () {
    ReactGA.initialize(appProps.googleAnalyticsId);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}